export class DraftReportDto {
    id;
    subject;
    summary;
    isPrivate;
    severityLevel;
    createdAt;
    categories;
    subCategories;
    respondingAgencies;
    media;
    createdById;
    reportedBy;
    contactRefrences;
    get images() {
        return this.media.filter((m) => m.type === "Image");
    }
    get videos() {
        return this.media.filter((m) => m.type === "Video");
    }
    constructor(obj) {
        Object.assign(this, obj);
    }
    static create(obj) {
        return new DraftReportDto(obj);
    }
}
//# sourceMappingURL=DraftReportDto.js.map